import React from 'react';
import { withStyles, withTheme } from '@material-ui/core';
import styles from '../styles';
import { compose } from 'recompose';
import { withUserProfile } from '../../../../userProfile/userProfileContext';
import { postData } from '../../../../api/componentAPIs';
import AppearanceIcon from './AppearanceIcon';
import { displayStyles, themesConfig } from './displayStyles';

const Display = (props) => {
  const { classes, theme, userData } = props;
  const { themeName } = theme;

  const toggleTheme = (theme) => {
    userData.toggleTheme(theme);
    postData('SetUserPreferences', { theme })
      .then((response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          console.log('Saved theme changes');
        }
      })
      .catch((error) => console.log('Failed to save theme changes', error));
  };

  const renderAppearanceOption = (themeConfig) => {
    const { themeCardLabel, colors } = themeConfig;
    return (
      <div>
        <div
          key={themeConfig.themeName}
          className={`${classes.appearanceOption} ${
            themeConfig.themeName === themeName ? classes.appearanceActive : ''
          }`}
          onClick={() => toggleTheme(themeConfig.themeName)}>
          <AppearanceIcon {...colors} />
        </div>
        <div className={classes.appearanceName}>{themeCardLabel}</div>
      </div>
    );
  };

  const renderGroup = (themeCardTitle) => {
    const filteredThemes = themesConfig.filter((theme) => theme.themeCardTitle === themeCardTitle);
    return (
      <div>
        <div className={classes.appearanceTitle}>{themeCardTitle}</div>
        <div className={classes.appearanceOptions}>
          {filteredThemes.map((themeConfig) => renderAppearanceOption(themeConfig))}
        </div>
      </div>
    );
  };

  return (
    <>
      <header className={classes.moduleHeader} data-automationid="display-title">
        Display Preferences
      </header>
      <div className={classes.appearanceContainer}>
        <div className={classes.appearanceText}>Appearance</div>
        <div className={classes.appearanceGroupContainer}>
          {/* {renderGroup('legacy theme')} */}
          {renderGroup('theme')}
        </div>
      </div>
    </>
  );
};

export default compose(
  withStyles((theme) => ({
    ...styles(theme),
    ...displayStyles(theme)
  })),
  withTheme(),
  withUserProfile
)(Display);
